import './App.css';
import Layout from './layout/index.js';
import { useEffect } from 'react';
import { Toaster,toast,toastStyles } from "react-hot-toast";
import Cookies from 'js-cookie';
import Login from './modules/auth/Login/Login.js';
import ForgotPassword from './modules/auth/Forgot/forgotPassword.js';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import GenerateOtp from './modules/auth/Forgot/generateOtp.js';
import io from 'socket.io-client';
import { debounce } from 'lodash';
import FoodData102 from './modules/food/foodData102.js';
import FoodData103 from './modules/food/foodData103.js';
import FoodData104 from './modules/food/foodData104.js';
import FoodData111 from './modules/food/foodData111.js';
import FoodData105 from './modules/food/foodData105.js';
import FoodData106 from './modules/food/foodData106.js';
import FoodData107 from './modules/food/foodData107.js';
import { useKotContext } from './modules/context/kotContext.js';
import FoodData109 from './modules/food/foodData109.js';
import { ShowSidebarProvider } from './modules/context/showSidebarContext.js';
import FoodData122 from './modules/food/foodData122.js';
import axios from 'axios';

const socket = io('https://api.rcb.tdrsoftware.in');

function App() {
   const fetchTableData = async (customerId,tableNo) => {
    try {
      const response = await axios.get(`https://api.rcb.tdrsoftware.in/api/getItems/${customerId}/${tableNo}`);
      // setOrder(prev => ({
      //   ...prev,
      //   [tableNo]: response.data.items,
      // }));
      // setFields(prev => ({
      //   ...prev,
      //   [tableNo]: response.data,
      // }));
    } catch (error) {
      // Handle error
    }
  };
  //const customerId = localStorage.getItem('customerId');
  const {updateServerName}=useKotContext()
  useEffect(() => {
    const customerId = localStorage.getItem('customerId');
    const notificationSound=new Audio("/new-notification-09-352705.mp3") // Assuming you store customerId in cookies
  
    // Join a room for this customerId
    socket.emit('joinRoom', customerId);
  
    // Listen for KOT generation events only for this room
    socket.on('kotGenerated', (data) => {
      notificationSound.play().catch((error) => {
      console.warn("Auto-play was prevented:", error);
    });
    //fetchTableData(customerId,data.tableNo)
      updateServerName(customerId,data.serverName,data.tableNo)
      if(data.message){
     toast.custom((t) => (
  <div style={{
    padding: '16px',
    backgroundColor: '#4CAF50',
    color: '#fff',
    fontSize:"14px",
    borderRadius: '4px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '280px',
    boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.2)',
  }}>
    <span>{data.message}</span>
    <button
      onClick={() => toast.dismiss(t.id)}
      style={{
        background: 'none',
        border: 'none',
        color: '#fff',
        fontSize: '14px',
        marginLeft: '8px',
        cursor: 'pointer',
      }}
    >
      ✖
    </button>
  </div>
), {
  id: `${Date.now()}-${Math.random()}`, // 👈 Ensures every toast is unique
  duration: Infinity,
}); }
     // console.log(Received KOT event: ${data.message}, 'msg');
    });
    
  
    return () => {
      socket.off('kotGenerated'); // Clean up the listener on component unmount
    };
  }, []);
  
  
  const token = Cookies.get('token'); // Check if token exists
 // console.log(token, 'token');
  //console.log(serverName, 'serverName');

  return (
    <>
      {/* <Toaster
        toastOptions={{
          className: '',
          style: {
            padding: '10px',
            color: '#713200',
            width: "300px"
          },
        }}
      /> */}
      <Toaster
  position="top-left"
  toastOptions={{
    duration: 5000,
    style: {
      padding: '8px',
      color: '#fff',
      background: '#4CAF50',
    },
  }}
  containerStyle={{
    top: 10,
    left: 400,
  }}
/>

      {/* Define Router here at the top-level */}
      
        <Routes>
          {/* Protected Route: Only accessible when token is present */}
          {token ? (
            
            <Route path="/*" element={<Layout />} />
            
          ) : (
            <>
              {/* Public routes for Login and Forgot Password */}
              <Route path="/login" element={<Login />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/generate-otp" element={<GenerateOtp/>} />
              <Route path="/foodData102" element={<FoodData102/>} />
              <Route path="/foodData103" element={<FoodData103/>} />
              <Route path="/foodData104" element={<FoodData104/>} />
              <Route path="/foodData111" element={<FoodData111/>} />
              <Route path="/foodData105" element={<FoodData105/>} />
              <Route path="/foodData106" element={<FoodData106/>} />
              <Route path="/foodData107" element={<FoodData107/>} />
              <Route path="/foodData109" element={<FoodData109/>} />
              <Route path="/foodData122" element={<FoodData122/>} />

              {/* Redirect any other route to /login if no token */}
              <Route path="*" element={<Navigate to="/login" />} />
            </>
          )}
        </Routes>
     
    </>
  );
}

export default App;
